import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import Select from 'react-select';
import { useIntl } from 'react-intl'
import { remoteOptions } from '../../helpers/select'

function RemoteSelect({ id, value, onChange, placeholder, allowEmpty }) {
    const intl = useIntl()
    const [selected, setSelected] = useState(null)

    useEffect(() => {
        setSelected(remoteOptions.find(o => value === o.value) ?? null)
    }, [value])

    const handleChange = option => {
        if (allowEmpty && selected?.value === option.value) {
            onChange(null)
            return
        }
        onChange(option.value)
    }

    return (
        <Select
            inputId={id}
            className='react-select-container'
            classNamePrefix='react-select'
            loadingMessage={() => intl.formatMessage({ id: "forms.select.loading" })}
            noOptionsMessage={() => intl.formatMessage({ id: "forms.select.no-options" })}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.value}
            value={selected}
            options={remoteOptions}
            openMenuOnFocus={true}
            placeholder={placeholder ?? intl.formatMessage({ id: "forms.remote.placeholder" })}
            onChange={handleChange}
        />
    )
}

RemoteSelect.defaultProps = {
    onChange: () => {
    },
    allowEmpty: false,
}

RemoteSelect.propTypes = {
    id: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    allowEmpty: PropTypes.bool,
}

export default RemoteSelect;
